import { IconSvg, IconSvgProps } from "./icon"

export default function ChevronRight(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m7.95 3.643 7.907 7.907a.617.617 0 0 1 0 .9L7.95 20.357" />
    </IconSvg>
  )
}
